import Button from '@atoms/Button/Button';
import Icon from '@atoms/Icon/Icon';
import Modal from '@atoms/Modal/Modal';
import Text from '@atoms/Text/Text';
import { IShareButton } from '@models/IShareButton';
import SocialLinks from '@molecules/SocialLinks/SocialLinks';
import { useRef, useState } from 'react';

const ShareButton = ({
  shareTitle,
  links,
  closeLabel,
  copyToClipboardLabel,
  copiedToClipboardLabel,
  allowCopyUrl,
  ariaShareLabel,
}: IShareButton) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCopiedToClipboard, setIsCopiedToClipboard] = useState(false);
  const shareButtonRef = useRef<HTMLButtonElement | null>(null);

  return (
    <div>
      <Button
        onClick={() => setIsOpen(true)}
        aria-label={ariaShareLabel}
        modifier="outline"
        variant="grey30"
        iconName="share"
        iconSize="1rem"
        buttonClasses="!tw-p-0 tw-h-[34px] tw-w-[34px]"
        iconClasses="tw-text-2xl"
        ref={shareButtonRef}
      />
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        restoreFocusRef={shareButtonRef}
      >
        <div className="tw-fixed tw-left-1/2 tw-top-1/2 tw-min-w-80 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-bg-white tw-p-4">
          {isCopiedToClipboard ? (
            <div className="tw-flex tw-gap-2">
              <Icon className="tw-text-black" name="share" size={20} />
              <Text variant="body-14-semibold">{copiedToClipboardLabel}</Text>
            </div>
          ) : (
            <div className="tw-mb-4 tw-flex tw-w-full tw-justify-between">
              <Text variant="body-14-semibold">{shareTitle}</Text>
              <button
                type="button"
                aria-controls="page-modal"
                aria-label={closeLabel}
                onClick={() => setIsOpen(false)}
                className="tw-flex"
              >
                <Icon className="tw-text-black" name="cross" size={20} />
              </button>
            </div>
          )}
          {!isCopiedToClipboard && (
            <SocialLinks
              links={links}
              copyToClipboardLabel={
                allowCopyUrl ? copyToClipboardLabel : undefined
              }
              onCopyToClipboard={() => {
                setIsCopiedToClipboard(true);
                setTimeout(() => {
                  setIsOpen(false);
                  setIsCopiedToClipboard(false);
                }, 3000);
              }}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

export default ShareButton;
